import { z } from 'zod';

export const npsScoreFormSchema = z.object({
  score: z.number().int().min(0).max(100).multipleOf(10),
});
export type NpsScoreFormValues = z.infer<typeof npsScoreFormSchema>;

export const npsContactFormSchema = z.object({
  observation: z.string().optional(),
  contactMe: z.boolean(),
});
export type NpsContactFormValues = z.infer<typeof npsContactFormSchema>;
